import o, { useState as h } from "react";
import { Text as v } from "../Text/Text.js";
import { HelpText as O } from "../HelpText/HelpText.js";
import { parseMinMax as T, parseValueBetween as D, percentTrack as f } from "../../helpers/numberHelper.js";
import { cls as E } from "../../helpers/cls.js";
import { sliderDefaultProps as k } from "./props.js";
var B = Object.defineProperty,
  b = Object.getOwnPropertySymbols,
  P = Object.prototype.hasOwnProperty,
  $ = Object.prototype.propertyIsEnumerable,
  x = (e, l, r) => l in e ? B(e, l, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : e[l] = r,
  I = (e, l) => {
    for (var r in l || (l = {})) P.call(l, r) && x(e, r, l[r]);
    if (b) for (var r of b(l)) $.call(l, r) && x(e, r, l[r]);
    return e;
  };
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const n = e => {
  const [l, r] = h(!1),
    [a, t] = T(e.min, e.max),
    d = D(e.value, a, t),
    s = () => r(!1),
    c = () => r(!0),
    y = () => r(!1),
    w = i => {
      var _;
      (_ = e.onChange) == null || _.call(e, Number(i.target.value));
    },
    S = i => {
      (i.key === "ArrowLeft" || i.key === "ArrowRight") && !l && r(!0);
    },
    m = f(0, a, t),
    p = f(d, a, t),
    g = "var(--color-feedback-error-100)",
    N = l ? "var(--color-secondary-100)" : "var(--color-neutral-110)",
    u = e.error ? g : N;
  return o.createElement("div", {
    className: "olx-slider"
  }, o.createElement("div", {
    className: "olx-slider__content"
  }, o.createElement("div", I({
    className: E("olx-slider__track", e.disabled && "olx-slider__track--disabled")
  }, !e.disabled && {
    style: {
      "--linear-gradient": "linear-gradient(to right, var(--color-neutral-90) ".concat(m, "%, ").concat(u, " ").concat(m, "%, ").concat(u, " ").concat(p, "%, var(--color-neutral-90) ").concat(p, "%)")
    }
  })), o.createElement("input", {
    className: E("olx-slider__input", e.error && "olx-slider__input--error"),
    "data-ds-component": "DS-Slider",
    type: "range",
    min: a,
    max: t,
    step: e.step,
    disabled: e.disabled,
    id: e.id,
    value: d,
    onTouchEnd: s,
    onTouchStart: c,
    onMouseUp: s,
    onMouseDown: c,
    onKeyUp: S,
    onBlur: y,
    onInput: w
  })), o.createElement("div", {
    className: "olx-slider__overline"
  }, o.createElement(v.BodySmall, {
    color: e.disabled ? "--color-neutral-90" : void 0,
    weight: "regular"
  }, a), o.createElement(v.BodySmall, {
    color: e.disabled ? "--color-neutral-90" : void 0,
    weight: "regular"
  }, t)), e.helpText && o.createElement("div", {
    className: "olx-slider__helptext"
  }, o.createElement(O, {
    isError: e.error
  }, e.helpText)));
};
n.displayName = "Slider", n.defaultProps = k;
export { n as Slider };